import { CCarousel, CCarouselCaption, CCarouselItem, CImage } from '@coreui/bootstrap-react/src/index';
import AngularImg from "../../../../content/1.0/assets/images/angular.jpg";
import ReactImg from "../../../../content/1.0/assets/images/react.jpg";
import VueImg from "../../../../content/1.0/assets/images/vue.jpg";
import * as React from 'react';
export default {
  CCarousel,
  CCarouselCaption,
  CCarouselItem,
  CImage,
  AngularImg,
  ReactImg,
  VueImg,
  React
};